
<div class="gantt-chart-host" [attr.id]="divId" #GanttChartMainContainer></div>

<!-- <div id="d3Tooltip"> 
  <app-transaction-detail-popup *ngIf="showGanttTooltip" [transactionName]="transactionName" [transactionData]="transactionData" (showGanttTooltip)="toolTipHide()"></app-transaction-detail-popup>
  <app-simple-change-popup *ngIf="showChangeTooltip" [transactionName]="transactionName" [transactionData]="transactionData" (showChangeTooltip)="toolTipHide()"></app-simple-change-popup>
  <app-pending-information-popup *ngIf="showPendingTooltip" [pendingInformation]="pendingInformation" (showPendingTooltip)="tooltipPendingHide()"></app-pending-information-popup>
  <div *ngIf="showPointerTooltip" (mouseout)="showPointerTooltip = !showPointerTooltip">
    <div class="pointer_container p-1">
      <div class="pointer_text">
        {{pointerTooltipData.replaceAll('br>', ': ').replaceAll('<','').replaceAll('undefined days','0')}}
      </div>
    </div>
  </div>
</div> -->

<ng-template #showGanttCustomTooltip>
  <app-transaction-detail-popup [transactionName]="transactionName" [transactionData]="transactionData" (showGanttTooltip)="hideCustomTooltip()"></app-transaction-detail-popup>
</ng-template>

<ng-template #showChangeCustomTooltip>
  <app-simple-change-popup [transactionName]="transactionName" [transactionData]="transactionData" (showChangeTooltip)="hideCustomTooltip()"></app-simple-change-popup>
</ng-template>

<ng-template #showPendingCustomTooltip>
  <app-pending-information-popup [pendingInformation]="pendingInformation" (showPendingTooltip)="hideCustomTooltip()"></app-pending-information-popup>
</ng-template>

<ng-template #showPointerCustomTooltip>
  <div class="pointer_container p-1">
    <div class="pointer_text">
      {{pointerTooltipData?.replaceAll('br>', ': ').replaceAll('<','').replaceAll('undefined days','0')}}
    </div>
  </div>
</ng-template>

<!-- <div id="d3Tooltip"> 
  <div *ngIf="showPointerTooltip" (mouseout)="showPointerTooltip = !showPointerTooltip">
    <div class="pointer_container p-1">
      <div class="pointer_text">
        {{pointerTooltipData.replaceAll('br>', ': ').replaceAll('<','').replaceAll('undefined days','0')}}
      </div>
    </div>
  </div>
</div> -->
